import type { ColumnDef } from "@tanstack/table-core";
import { TextWithOverflowTooltip } from "src/components/TextWithOverflowTooltip";
import { formatUuid } from "src/services/id";
import { ColumnId } from "./constants";

type Row = { id: { formId: uuid; formSchoolRankId: uuid | null } };

export function buildIdColumnDef<T extends Row>(): ColumnDef<T> {
  return {
    id: ColumnId.ID,
    header: "ID",
    cell: (props) => (
      <TextWithOverflowTooltip
        content={formatUuid(props.row.original.id.formId)}
        maxWidth="9em"
      />
    ),
  };
}

export function buildFormSchoolRowIdColumnDef<T extends Row>(): ColumnDef<T> {
  return {
    id: ColumnId.FormSchoolRowId,
    header: "Form school row ID",
    cell: (props) => (
      <TextWithOverflowTooltip
        content={
          props.row.original.id.formSchoolRankId
            ? formatUuid(props.row.original.id.formSchoolRankId)
            : ""
        }
        maxWidth="9em"
      />
    ),
  };
}
